(function(){
window.scpdInit = init; function init(){
  var el=document.getElementById('scpd');
  if(!el)return;
  var dataEl=document.getElementById('scpd-data');
  if(!dataEl)return;
  var P;
  try{P=JSON.parse(dataEl.textContent)}catch(e){return}

  var list=document.getElementById('scpd-list');
  var cart=document.getElementById('scpd-cart');
  var countEl=document.getElementById('scpd-count');
  var curQty=P.packQty||3;
  var selected=[];
  var groupsCache=[];

  function fmt(n){return '$'+Math.round(n).toLocaleString('es-CL')}

  function getGroups(){
    var groups=[];var seen={};
    P.variants.forEach(function(v){
      var color=v.options[0]||v.title;
      if(!seen[color]){
        seen[color]=true;
        var sizes=[];
        P.variants.forEach(function(v2){
          if(v2.options[0]===color){
            sizes.push({id:v2.id,label:v2.options[1]||v2.title,available:v2.available!==false});
          }
        });
        var anyAvail=sizes.some(function(s){return s.available});
        groups.push({color:color,image:v.image||P.image,price:Math.round(v.priceCents/100),sizes:sizes,available:anyAvail});
      }
    });
    return groups;
  }

  function isSelected(gi){return selected.some(function(s){return s.gi===gi&&!s.isDup})}
  function selectedGroup(gi){return selected.find(function(s){return s.gi===gi&&!s.isDup})}
  function dupCount(gi){return selected.filter(function(s){return s.gi===gi&&s.isDup}).length}

  function render(){
    groupsCache=getGroups();
    var html='';
    groupsCache.forEach(function(g,gi){
      var sel=isSelected(gi);
      var dups=dupCount(gi);
      var itemCls='scpd__item'+(g.available?'':' scpd__item--out')+(sel?' scpd__item--sel':'');
      html+='<div class="'+itemCls+'" data-gi="'+gi+'" id="scpd-item-'+gi+'">';
      html+='<img src="'+(g.image||P.image)+'" class="scpd__item-img">';
      html+='<div class="scpd__item-info">';
      html+='<div class="scpd__item-name">'+P.title+' '+g.color+'</div>';
      html+='<div class="scpd__item-price">'+fmt(g.price)+'</div>';
      if(g.available){
        html+='<div class="scpd__item-label">TALLA</div>';
        html+='<div class="scpd__item-sizes" data-gi="'+gi+'">';
        var firstAvailIdx=-1;for(var fi=0;fi<g.sizes.length;fi++){if(g.sizes[fi].available){firstAvailIdx=fi;break}}
        var current=selectedGroup(gi);
        g.sizes.forEach(function(s,si){
          var isActive=current?(current.variantId===s.id):(si===firstAvailIdx);
          var cls='scpd__size'+(isActive?' scpd__size--active':'')+(s.available?'':' scpd__size--out');
          var ttl=s.available?s.label:s.label+' - Sin stock';
          html+='<button type="button" class="'+cls+'" data-vid="'+s.id+'" data-gi="'+gi+'" title="'+ttl+'"'+(s.available?'':' disabled')+'>'+s.label+'</button>';
        });
        html+='</div>';
      } else {
        html+='<div class="scpd__item-out-msg">Sin stock disponible</div>';
      }
      if(dups>0){html+='<div class="scpd__item-dup-tag">+'+dups+' duplicado'+(dups>1?'s':'')+'</div>'}
      html+='</div>';
      if(g.available){
        html+='<button type="button" class="scpd__elige'+(sel?' scpd__elige--done':'')+'" data-gi="'+gi+'">'+(sel?'Elegido ✓':'Elige')+'</button>';
      } else {
        html+='<button type="button" class="scpd__elige scpd__elige--out" disabled>Sin stock</button>';
      }
      html+='</div>';
    });
    list.innerHTML=html;

    // Size clicks
    list.querySelectorAll('.scpd__size').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(btn.classList.contains('scpd__size--out'))return;
        var container=btn.closest('.scpd__item-sizes');
        container.querySelectorAll('.scpd__size').forEach(function(b){b.classList.remove('scpd__size--active')});
        btn.classList.add('scpd__size--active');
        // Update variant ID in selected if already chosen
        var gi=parseInt(btn.dataset.gi);
        var s=selectedGroup(gi);
        if(s)s.variantId=parseInt(btn.dataset.vid);
      });
    });

    // Elige clicks
    list.querySelectorAll('.scpd__elige:not(.scpd__elige--out)').forEach(function(btn){
      btn.addEventListener('click',function(){
        var gi=parseInt(btn.dataset.gi);
        var item=list.querySelector('#scpd-item-'+gi);
        var activeSize=item.querySelector('.scpd__size--active');
        var varId=activeSize?parseInt(activeSize.dataset.vid):0;

        if(btn.classList.contains('scpd__elige--done')){
          // Remove this item + its duplicates
          selected=selected.filter(function(s){return s.gi!==gi});
          render();updateCount();renderTopUp();
        } else {
          if(selected.length>=curQty)return;
          if(!varId)return;
          selected.push({gi:gi,variantId:varId,isDup:false});
          render();updateCount();renderTopUp();
        }
      });
    });

    renderTopUp();
    updateCount();
  }

  function renderTopUp(){
    var topUpEl=document.getElementById('scpd-topup');
    if(!topUpEl){
      topUpEl=document.createElement('div');
      topUpEl.id='scpd-topup';
      topUpEl.className='scpd__topup';
      list.parentNode.insertBefore(topUpEl,list.nextSibling);
    }

    if(selected.length>=curQty){topUpEl.style.display='none';topUpEl.innerHTML='';return}

    var unselectedAvailable=groupsCache.filter(function(g,i){return g.available&&!isSelected(i)}).length;
    var canCompleteNormally=selected.length+unselectedAvailable>=curQty;
    if(canCompleteNormally||selected.length===0){topUpEl.style.display='none';topUpEl.innerHTML='';return}

    var faltan=curQty-selected.length;
    var html='<div class="scpd__topup-msg">&#9888; Algunos productos sin stock. Completa con +1 m&aacute;s de los elegidos:</div>';
    html+='<div class="scpd__topup-btns">';
    selected.filter(function(s){return !s.isDup}).forEach(function(s){
      var g=groupsCache[s.gi];if(!g)return;
      html+='<button type="button" class="scpd__topup-btn" data-vid="'+s.variantId+'" data-gi="'+s.gi+'">+1 m&aacute;s '+g.color+'</button>';
    });
    html+='</div>';
    topUpEl.innerHTML=html;
    topUpEl.style.display='block';

    topUpEl.querySelectorAll('.scpd__topup-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(selected.length>=curQty)return;
        var gi=parseInt(btn.dataset.gi);
        var vid=parseInt(btn.dataset.vid);
        selected.push({gi:gi,variantId:vid,isDup:true});
        render();updateCount();renderTopUp();
      });
    });
  }

  function updateCount(){
    countEl.innerHTML='Seleccionados: <strong>'+selected.length+' de '+curQty+'</strong>';
    if(selected.length>=curQty){
      cart.disabled=false;
      cart.textContent='AGREGAR PACK AL CARRITO';
      cart.classList.add('scpd__cart--ready');
    } else {
      cart.disabled=true;
      var f=curQty-selected.length;
      cart.textContent='FALTA ELEGIR '+f+' PRODUCTO'+(f>1?'S':'');
      cart.classList.remove('scpd__cart--ready');
    }
  }

  cart.addEventListener('click',function(){
    if(selected.length<curQty)return;
    /* Agrupar por variantId para enviar quantity correcta */
    var qtyByVid={};
    selected.forEach(function(s){qtyByVid[s.variantId]=(qtyByVid[s.variantId]||0)+1});
    var items=Object.keys(qtyByVid).map(function(vid){return{id:parseInt(vid),quantity:qtyByVid[vid]}});
    cart.textContent='Agregando...';cart.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json()}).then(function(){
      cart.textContent='Pack agregado!';
      setTimeout(function(){if(window.scOpenCartDrawer){scOpenCartDrawer()}else{window.location.href='/cart'}},800);
    }).catch(function(){cart.textContent='AGREGAR PACK AL CARRITO';cart.disabled=false});
  });

  render();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(init,500)})}
else{setTimeout(init,500)}
})();
